/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ valueText: NonNullable<unknown> }} Onboarding_Weight_MessageInputs */

const en_us2_onboarding_weight_message = /** @type {(inputs: Onboarding_Weight_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`My weight is ${i?.valueText}`)
};

const pt_br2_onboarding_weight_message = /** @type {(inputs: Onboarding_Weight_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Meu peso é ${i?.valueText}`)
};

const es_419_onboarding_weight_message = /** @type {(inputs: Onboarding_Weight_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mi peso es ${i?.valueText}`)
};

const pt_pt2_onboarding_weight_message = /** @type {(inputs: Onboarding_Weight_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O meu peso é ${i?.valueText}`)
};

const fr_fr2_onboarding_weight_message = /** @type {(inputs: Onboarding_Weight_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Je pèse ${i?.valueText}`)
};

const de_de2_onboarding_weight_message = /** @type {(inputs: Onboarding_Weight_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ich wiege ${i?.valueText}`)
};

const it_it2_onboarding_weight_message = /** @type {(inputs: Onboarding_Weight_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Peso ${i?.valueText}`)
};

/**
* | output |
* | --- |
* | "My weight is {valueText}" |
*
* @param {Onboarding_Weight_MessageInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_weight_message = /** @type {((inputs: Onboarding_Weight_MessageInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Weight_MessageInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_weight_message(inputs)
	if (locale === "es-419") return es_419_onboarding_weight_message(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_weight_message(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_weight_message(inputs)
	if (locale === "de-DE") return de_de2_onboarding_weight_message(inputs)
	if (locale === "it-IT") return it_it2_onboarding_weight_message(inputs)
	return en_us2_onboarding_weight_message(inputs)
});
export { onboarding_weight_message as "onboarding.weight.message" }